import { isSherbertAssetUrl } from './isAssetUrl';
export var AssetUrlParseError;
(function (AssetUrlParseError) {
    AssetUrlParseError["InvalidUrl"] = "Asset URL has to be a Sherbert V2 url";
    AssetUrlParseError["NoAssetId"] = "Asset id wasn't found";
})(AssetUrlParseError || (AssetUrlParseError = {}));
/** Parses id, signature and variants from a Sherbert V2 asset url */
export function parseAssetUrl(url) {
    var _a, _b, _c;
    if (!isSherbertAssetUrl(url)) {
        throw new Error(AssetUrlParseError.InvalidUrl);
    }
    // extract id and variants part from the url
    const regex = new RegExp(/.*\/assets\/(?<idVariants>[^?]*)[?]?.*/i);
    const { idVariants } = (_b = (_a = url.match(regex)) === null || _a === void 0 ? void 0 : _a.groups) !== null && _b !== void 0 ? _b : {};
    if (!idVariants) {
        throw new Error(AssetUrlParseError.NoAssetId);
    }
    const [id, ...variants] = idVariants.split('/').filter((item) => item !== '');
    const signature = (_c = new URL(url).searchParams.get('signature')) !== null && _c !== void 0 ? _c : undefined;
    return {
        id,
        signature,
        variants: variants.length ? variants : undefined,
    };
}
//# sourceMappingURL=parseAssetUrl.js.map